import React from 'react';
import { Hero } from './components/Hero';
import { SocialProof } from './components/SocialProof';
import { PainPoints } from './components/PainPoints';
import { Solution } from './components/Solution';
import { Tomos } from './components/Tomos';
import { Bonuses } from './components/Bonuses';
import { Risk } from './components/Risk';
import { Pricing } from './components/Pricing';
import { Guarantee } from './components/Guarantee';
import { FAQ } from './components/FAQ';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { PurchaseNotifications } from './components/PurchaseNotifications';
export function App() {
  return <div className="w-full bg-white font-sans text-ink" data-id="element-0" data-mp="2wk0a329kipw1">
      <main data-id="element-1" data-mp="2wiferaffj2x4">
        <Hero data-id="element-2" data-mp="2wip7h5ruzo6i" />
        <SocialProof data-id="element-3" data-mp="2wi5nzkmk8rqd" />
        <PainPoints data-id="element-4" data-mp="28u5ysp4wd9dw" />
        <Solution data-id="element-5" data-mp="28tmifcuwat1z" />
        <Tomos data-id="element-6" data-mp="28suumo7jhzm9" />
        <Bonuses data-id="element-7" data-mp="28skzynbjv4a8" />
        <Risk data-id="element-8" data-mp="28s30zixi6bym" />
        <Pricing data-id="element-9" data-mp="23vkuoemiy5k6" />
        <Guarantee data-id="element-10" data-mp="23w4drynwuzzs" />
        <FAQ data-id="element-11" data-mp="23ujl6el5pr4k" />
        <FinalCTA data-id="element-12" data-mp="23v2rsz5cwt3a" />
      </main>
      <Footer data-id="element-13" data-mp="3ijxokogyjwiu" />
      <PurchaseNotifications data-id="element-14" data-mp="3ikh829m9asyz" />
    </div>;
}